<template>
    <div>
        <footer class="footer">
            <div class="inner">
                <div class="footer-info">
                    <div class="footer-addres">
                        <div class="addres" :class="active == 1 ? 'active':''" @mouseenter="onEnter(1)">
                            <span>
                                苏州<em>SuZhou</em>
                            </span> 
                            <small>
                                <em>苏州办公区</em>
                                <address>地址：苏州市吴中区吴中大道1421号太湖软件园6号楼13层</address>
                            </small>
                        </div>
                        <div class="addres" :class="active == 2 ? 'active':''" @mouseenter="onEnter(2)">
                            <span>北京<em>BeiJing</em></span> 
                            <small>
                                <em>北京办公区</em>
                                <address>地址：北京市海淀区北京理工大学国防科技园1号楼607</address>
                            </small>
                        </div>
                    </div>
                    <div class="footer-contact">
                        <em>联系我们</em>
                        <div class="contact-list">
                            <p>商业合作：marketing@bitilinks.cn</p>
                            <p>客户服务：service@bitilinks.cn</p>
                            <div class="link-icon">
                                <i class="icon"></i>
                                <i class="icon"></i>
                                <i class="icon"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer-des"> 
                    <div class="des-info">
                        <div class="info-list">
                            <span>应用</span>
                            <ul>
                                <li>标识解析企业节点</li>
                                <li>企业节点管控系统</li>
                                <li>碳值计算平台</li>
                                <li>主动标识载体管理平台</li>
                                <li>网站数据增强系统</li>
                                <li>Origin系列工业互联网平台</li>
                            </ul>
                        </div>
                        <div class="info-list">
                            <span>服务资讯</span>
                            <ul>
                                <li>标识解析体系建设</li>
                                <li>信息集成</li>
                                <li>整体规划设计</li> 
                            </ul>
                        </div>
                    </div>
                    <div class="des-link"> 
                        <div class="link-img">
                            <div class="link-wx">
                                <img :src="setImg('wx.jpg')" alt=""> 
                            </div>
                            <div class="link-wx">
                                <img :src="setImg('xcx.jpg')" alt=""> 
                            </div>
                        </div> 
                        <div class="link-logo">
                            <img :src="setImg('logo1.png')" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div class="copyright-info"> 
                @2021-2022理工比特林克（苏州）软件信息技术服务有限公司&nbsp;&nbsp;
                <a target="_blank" href="https://beian.miit.gov.cn">
                    苏ICP备2022009046号-1
                </a>
            </div>
        </footer>
        <div class="m-footer">
            <div class="footer-info">
                <div class="footer-contact">
                    <em>联系我们</em>
                    <div class="contact-list">
                        <p>商业合作：marketing@bitilinks.cn</p>
                        <p>客户服务：service@bitilinks.cn</p> 
                    </div>
                </div>
                <div class="footer-addres">
                    <title>办公地址</title>
                    <div class="addres" :class="active == 1 ? 'active':''" @mouseenter="onEnter(1)">
                        <span>
                            苏州<em>SuZhou</em>
                        </span> 
                        <small>
                            <em>苏州办公区</em>
                            <address>地址：苏州市吴中区吴中大道1421号太湖软件园6号楼13层</address>
                        </small>
                    </div>
                    <div class="addres" :class="active == 2 ? 'active':''" @mouseenter="onEnter(2)">
                        <span>北京<em>BeiJing</em></span> 
                        <small>
                            <em>北京办公区</em>
                            <address>地址：北京市海淀区北京理工大学国防科技园1号楼607</address>
                        </small>
                    </div>
                </div> 
            </div>
            <div class="copyright-info"> 
                @2021-2022理工比特林克（苏州）软件信息技术服务有限公司&nbsp;&nbsp;
                <a target="_blank" href="https://beian.miit.gov.cn">
                    苏ICP备2022009046号-1
                </a> 
            </div>
        </div>
    </div>
</template>
<script>  
    import store from '@/store';
    export default {
        name: "FooterPage",
        data() {
            return { 
                active: 1 
            };
        },
        created() {   
        },
        methods: { 
            onEnter(index){ 
                this.active = index; 
                store.dispatch('app/toggleActive', index)
            },
            setImg(path) {
                return require(`@/assets/images/${path}`)
            }
        },
    };
</script>
<style lang="scss">
@import "@/assets/scss/mixins/_variables"; 
.m-footer{
    display: none;
}
.footer{
    padding-top:400px;
    height: 1144px;
    color:#fff;
    font-size:18px;
    background: url('~@/assets/images/footer.png') no-repeat;
    background-size: 100% 100%;
    &-info{
        width:100%;
        display: flex;
        justify-content:space-between;
        .footer-addres{ 
            margin-top: 10px; 
            span{
                margin-right: 160px;
                em{
                    display: block;
                    margin-top: 20px;
                    height: 25px;
                    line-height: 25px;
                }
            }
            .addres{
                display: flex; 
                width:100%; 
                font-size:25px; 
                margin-bottom:42px;
                address{
                    height: 20px;
                    line-height: 20px;
                    margin-top:30px;
                    font-size: 20px;
                }
            }
        }
        .footer-contact{
            margin-top: 10px;
            em{
                font-size: 25px;
            }
            p{
                font-size:20px;
                margin-top: 30px;
                height: 20px;
                line-height: 20px;
            }
            .link-icon{
                display: flex;
                justify-content:space-between;
                align-items:center;
                margin-top:47px;
                i.icon{
                    width:46px;
                    height:38px;
                    &:nth-child(1){
                        background: url('~@/assets/images/icon/icon-email.png') no-repeat center center;
                        background-size: 38px 26px;
                    }
                    &:nth-child(2){
                        background: url('~@/assets/images/icon/icon-wx.png') no-repeat center center;
                        background-size: 46px 37px;
                    }
                    &:nth-child(3){
                        background: url('~@/assets/images/icon/icon-wb.png') no-repeat center center;
                        background-size: 44px 38px;
                    }
                }
            }
        }
    }
    &-des{
        display: flex;
        justify-content:space-between;
        margin-top: 150px;
        .des-info{
            display: flex;
            justify-content:space-between;
            .info-list{
                &:nth-child(1){
                    width: 476px;
                    margin-right: 133px;
                    ul{ 
                        display: flex;
                        flex-wrap:wrap;
                        justify-content:space-between;
                        li{
                            width:50%; 
                        }
                    }
                }
                span{
                    display: block;
                    font-size: 25px;
                    line-height: 25px;
                    height: 47px;
                    margin-bottom: 16px;
                    padding-bottom:22px;
                    border-bottom: 1px solid #fff;
                }
                ul{  
                    li{ 
                        margin-bottom: 24px;
                        font-size:18px;
                        height: 18px;
                        line-height: 18px;
                    }
                }
            }
        }
        .des-link{
            width: 270px;
        }
        .link-img{
            display: flex;
            justify-content:space-between;
            .link-wx{
                width:127px;
                height: 124px;
                text-align: center;
            }
            
        }
        .link-logo{
            width:124px;
            height:34px;
            margin:12px auto 0;
        }
    }
    .copyright-info{
        margin-top: 50px; 
        text-align: center;
        height: 100px;
        line-height: 100px;
        border-top: 1px solid #fff;
        font-size:18px;
        a{
            color:#fff;
        } 
    }
}
@media only screen and (max-width: 750px) { 
    .footer{
        display: none;
    }
    .m-footer{
        display: block;
        margin-top: 30px;
        padding:30px 2% 0;
        background: #202020;
        color:#8a8a8a;
        .footer-info{
            display: block;
            .footer-addres{
                title{
                    display: block;
                    margin-bottom: 15px;
                    font-weight: bold;
                    color: #fff;
                    font-size: 25px;
                }
                .addres{
                    margin-bottom: 15px;
                    font-size: 24px;
                    address{
                        font-size:18px;
                        margin-top: 10px;
                    }
                }
                span{
                    margin-right:30px;
                }
            }
            .footer-contact{
                margin-top: 0;
                em{
                    font-weight: bold;
                    color:#fff;
                }
                .contact-list{
                    margin-bottom: 15px;
                    p{
                        margin-top: 10px;
                        font-size: 18px;
                    }
                }
            }
        }
        .copyright-info{
            padding:15px 0;
            border-top:1px solid #fff;
            font-size:14px;
            text-align: center;
            a{
                color:#8a8a8a;
            } 
        }
    }
}
</style>
